import { useMutation } from "@apollo/client/react";
import { CREATE_GROUP } from "../../mutations/rolesAndPermissions/createGroup";
import GET_USER_GROUPS from "../../queries/rolesAndPermissions/getUserGroups";

export const useCreateGroup = ({
  onCompleted,
  onError,
}: {
  onCompleted: (result?: any) => void;
  onError: (e?: any) => void;
}) => {
  const [createGroup, { data, loading, error }] = useMutation(CREATE_GROUP, {
    onCompleted: onCompleted,
    onError: onError,
    refetchQueries: [GET_USER_GROUPS],
    awaitRefetchQueries: true,
  });

  return { createGroup, data, loading, error };
};
